import styles from "./FeatureUpvote.module.css";
import Icon from "@mdi/react";
import { mdiChevronUp } from "@mdi/js";
import AnimatedNumber from "animated-number-react";

// React
import React, { useState, useEffect } from "react";

// Tools
import Services from "tools/Services";

// context
import { useContext } from "react";
import { MyContext } from "components/RoleContext";
import { Role } from "tools/Enums";

export default function FeatureUpvote(props) {
	const { role } = useContext(MyContext);
	const [hasVoted, setHasVoted] = useState(props.feature.hasVoted);
	const [nbVotes, setNbVotes] = useState(props.feature.nbVotes);

	useEffect(() => {
		setHasVoted(props.feature.hasVoted);
		setNbVotes(props.feature.nbVotes);
	}, [props.feature.hasVoted, props.feature.nbVotes]);

	const handleClickUpvote = async () => {
		// Admins shouldn't vote
		if (role === Role.Admin) return;

		// POST
		const data = {
			idFeature: props.feature.idFeature,
			hasVoted: !hasVoted,
		};
		let res = await Services.post("/Feature/vote", data);

		// ERROR
		if (res.status !== 200) {
			console.error(res);
			return;
		}

		// SUCCESS
		props.onChangeState({ ...props.feature, hasVoted: !hasVoted, nbVotes: res.data.nbVotes });
	};

	const cssHasVoted = () => {
		return hasVoted ? "hasVotedToggle" : "";
	};

	const formatValue = (value) => value.toFixed(0);

	return (
		<div
			className={[role !== Role.Admin ? styles.upvoteToggle : styles.upvoteAdmin, styles[cssHasVoted()]].join(
				" "
			)}
			onClick={handleClickUpvote}
		>
			<div className={styles.itemToggle}>
				<Icon path={mdiChevronUp} size={1} />
			</div>
			<hr className={styles.lineToggle} />
			{/* <div className={styles.itemToggle}>{nbVotes}</div> */}
			<AnimatedNumber value={nbVotes} formatValue={formatValue} duration={300} className={styles.itemToggle} />
		</div>
	);
}
